"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_dom_1 = require("react-dom");
var classNames = require("classnames");
var react_popper_1 = require("react-popper");
var monitoring_1 = require("../../services/monitoring");
// Use a class component so we can get a reference.
var TargetChildren = /** @class */ (function (_super) {
    __extends(TargetChildren, _super);
    function TargetChildren() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TargetChildren.prototype.render = function () {
        return this.props.element;
    };
    return TargetChildren;
}(React.Component));
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.enterTimer = null;
        _this.leaveTimer = null;
        _this.touchTimer = null;
        _this.isControlled = null;
        _this.ignoreNonTouchEvents = false;
        _this.handleRequestOpen = function (event) {
            var children = _this.props.children;
            if (typeof children !== 'string') {
                var childrenProps = React.Children.only(children).props;
                if (event.type === 'focus' && childrenProps.onFocus) {
                    childrenProps.onFocus(event);
                }
                if (event.type === 'mouseover' && childrenProps.onMouseOver) {
                    childrenProps.onMouseOver(event);
                }
            }
            if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
                return;
            }
            clearTimeout(_this.leaveTimer);
            if (_this.props.enterDelay > 0) {
                _this.leaveTimer = setTimeout(function () {
                    _this.requestOpen(event);
                }, _this.props.enterDelay);
            }
            else {
                _this.requestOpen(event);
            }
        };
        _this.requestOpen = function (event) {
            if (!_this.isControlled) {
                _this.setState({ open: true });
            }
            if (_this.props.onRequestOpen) {
                _this.props.onRequestOpen(event, true);
            }
        };
        _this.handleRequestClose = function (event) {
            var children = _this.props.children;
            if (typeof children !== 'string') {
                var childrenProps = React.Children.only(children).props;
                if (event.type === 'blur' && childrenProps.onBlur) {
                    childrenProps.onBlur(event);
                }
                if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
                    childrenProps.onMouseLeave(event);
                }
            }
            clearTimeout(_this.leaveTimer);
            if (_this.props.leaveDelay) {
                _this.leaveTimer = setTimeout(function () {
                    _this.requestClose(event);
                }, _this.props.leaveDelay);
            }
            else {
                _this.requestClose(event);
            }
        };
        _this.requestClose = function (event) {
            _this.ignoreNonTouchEvents = false;
            if (!_this.isControlled) {
                _this.setState({ open: false });
            }
            if (_this.props.onRequestClose) {
                _this.props.onRequestClose(event, false);
            }
        };
        _this.handleTouchStart = function (event) {
            _this.ignoreNonTouchEvents = true;
            var children = _this.props.children;
            if (typeof children !== 'string') {
                var childrenProps = React.Children.only(children).props;
                if (childrenProps.onTouchStart) {
                    childrenProps.onTouchStart(event);
                }
            }
            clearTimeout(_this.touchTimer);
            event.persist();
            _this.touchTimer = setTimeout(function () {
                _this.handleRequestOpen(event);
            }, 1e3);
        };
        _this.handleTouchEnd = function (event) {
            var children = _this.props.children;
            if (typeof children !== 'string') {
                var childrenProps = React.Children.only(children).props;
                if (childrenProps.onTouchEnd) {
                    childrenProps.onTouchEnd(event);
                }
            }
            clearTimeout(_this.touchTimer);
            clearTimeout(_this.leaveTimer);
            event.persist();
            _this.leaveTimer = setTimeout(function () {
                _this.requestClose(event);
            }, 1500 + _this.props.leaveDelay);
        };
        _this.state = {};
        return _this;
    }
    Tooltip.prototype.componentDidMount = function () {
        monitoring_1.default('tooltip');
    };
    Tooltip.prototype.componentWillMount = function () {
        var props = this.props;
        this.isControlled = props.open !== undefined;
        if (!this.isControlled) {
            // not controlled, use internal state
            this.setState({
                open: false
            });
        }
    };
    Tooltip.prototype.componentWillUnmount = function () {
        clearTimeout(this.enterTimer);
        clearTimeout(this.leaveTimer);
    };
    Tooltip.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, disableTriggerFocus = _a.disableTriggerFocus, disableTriggerHover = _a.disableTriggerHover, disableTriggerTouch = _a.disableTriggerTouch, enterDelay = _a.enterDelay, id = _a.id, leaveDelay = _a.leaveDelay, openProp = _a.open, onRequestClose = _a.onRequestClose, onRequestOpen = _a.onRequestOpen, theme = _a.theme, title = _a.title, rawPlacement = _a.placement, _b = _a.PopperProps, PopperOther = __rest(_b === void 0 ? {} : _b, []), other = __rest(_a, ["children", "className", "disableTriggerFocus", "disableTriggerHover", "disableTriggerTouch", "enterDelay", "id", "leaveDelay", "open", "onRequestClose", "onRequestOpen", "theme", "title", "placement", "PopperProps"]);
        var placement = rawPlacement;
        var open = this.isControlled ? openProp : this.state.open;
        var childrenProp = children;
        var childrenProps = {};
        childrenProps['aria-describedby'] = id;
        if (!disableTriggerTouch) {
            childrenProps.onTouchStart = this.handleTouchStart;
            childrenProps.onTouchEnd = this.handleTouchEnd;
        }
        if (!disableTriggerHover) {
            childrenProps.onMouseOver = this.handleRequestOpen;
            childrenProps.onMouseLeave = this.handleRequestClose;
        }
        if (!disableTriggerFocus) {
            childrenProps.onFocus = this.handleRequestOpen;
            childrenProps.onBlur = this.handleRequestClose;
        }
        return (React.createElement(react_popper_1.Manager, __assign({ className: classNames('tooltip-root', className) }, other),
            React.createElement(react_popper_1.Target, null, function (_a) {
                var targetProps = _a.targetProps;
                return (React.createElement(TargetChildren, { element: typeof childrenProp !== 'string'
                        ? React.cloneElement(childrenProp, childrenProps)
                        : childrenProp, ref: function (node) {
                        targetProps.ref(react_dom_1.findDOMNode(node));
                    } }));
            }),
            React.createElement(react_popper_1.Popper, __assign({ placement: placement, eventsEnabled: open, className: classNames('tooltip__popper', {
                    tooltip__popper__close: !open
                }) }, PopperOther),
                React.createElement("div", { id: id, role: "tooltip", "aria-hidden": !open, className: classNames('tooltip', { 'tooltip--open': open }, "tooltip--" + placement.split('-')[0]) }, title))));
    };
    Tooltip.defaultProps = {
        disableTriggerFocus: false,
        disableTriggerHover: false,
        disableTriggerTouch: false,
        enterDelay: 0,
        leaveDelay: 0,
        placement: 'bottom'
    };
    return Tooltip;
}(React.Component));
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Tooltip/Tooltip.js
// module id = 254
// module chunks = 0